const uploader = document.querySelector(".custom-file-upload input");
if(uploader){
    uploader.addEventListener("change", function(){
        const fileName = this.files[0]?.name;
        const label = document.querySelector(".custom-file-upload .name");
        label.innerText = fileName ?? label.getAttribute('data-name');
    });
}

const selectElements = document.querySelectorAll('select');

selectElements.forEach(selectElement => {
  const firstOption = selectElement.querySelector('option:first-child');
  firstOption.disabled = true;
  firstOption.selected = true;
  firstOption.style.display = 'none';
  selectElement.required = true;
});

const dateFields = document.querySelectorAll('input.date-field');

dateFields.forEach(dateField => {
  dateField.addEventListener('focus', () => {
    dateField.type = 'date';
  });
});
